import styled, { keyframes } from 'styled-components';
import colors from 'styles/colors';

/** Painel lateral "Personalizar sua análise" da Análise do Edital (Gestão IA). */

const slideIn = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  /* acima do modal do card da Gestão IA (3000000001) */
  z-index: 3000000002;
  background: rgba(33, 53, 74, 0.35);
  display: flex;
  justify-content: flex-end;
`;

export const Panel = styled.div`
  width: 520px;
  max-width: 94vw;
  height: 100%;
  background: ${colors.$white};
  display: flex;
  flex-direction: column;
  animation: ${slideIn} 0.2s ease;

  .drawer-content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 16px;
  }

  .drawer-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
  }

  .drawer-head-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  .drawer-close {
    display: flex;
    align-items: center;
    padding: 0;
    border: none;
    background: none;
    color: ${colors.$gray700};
    cursor: pointer;

    .material-icons {
      font-size: 20px;
    }
  }

  .drawer-hint {
    margin: 8px 0 0;
    color: ${colors.$gray900};
    font-size: 14px;
    line-height: 1.35;
  }

  .dictate-row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    min-height: 32px;
    margin: 4px 0;
  }

  .dictate-wave {
    flex: 1;
    overflow: hidden;
  }

  .dictate {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 0;
    border: none;
    background: none;
    color: ${colors.$primary};
    font-size: 14px;
    cursor: pointer;

    .material-icons {
      font-size: 20px;
    }
  }

  .dictate-controls {
    display: flex;
    align-items: center;
    gap: 8px;

    button {
      display: inline-flex;
      align-items: center;
      padding: 0;
      border: none;
      background: none;
      cursor: pointer;

      &:disabled {
        cursor: default;
      }
    }

    .material-icons {
      font-size: 20px;
    }

    .dictate-cancel {
      color: ${colors.$danger};
    }

    .dictate-confirm {
      color: ${colors.$primary};
    }

    .dictate-transcribing {
      color: ${colors.$gray600};
      font-size: 13px;
    }
  }

  textarea {
    width: 100%;
    height: 260px;
    resize: vertical;
    padding: 10px 12px;
    background: ${colors.$white};
    border: 1px solid ${colors.$gray400};
    border-radius: 6px;
    color: ${colors.$gray900};
    font-size: 14px;
    line-height: 1.35;
    outline: none;

    &::placeholder {
      color: ${colors.$gray600};
    }

    &:focus {
      border-color: ${colors.$primary};
    }

    &:disabled {
      background: ${colors.$gray100};
    }
  }

  .improve-button {
    margin-top: 16px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    padding: 6px 16px;

    .improve-icon {
      width: 20px;
      height: 18px;
      margin-right: 8px;
    }
  }

  .drawer-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    padding: 16px;
    border-top: 1px solid ${colors.$gray300};
  }

  .drawer-error {
    flex: 1;
    margin: 0;
    color: ${colors.$danger};
    font-size: 13px;
  }

  .drawer-save {
    height: 38px;
    padding: 8px 24px;
    background: ${colors.$primary};
    border: 1px solid ${colors.$primary};
    border-radius: 6px;
    color: ${colors.$white};
    font-size: 15px;
    cursor: pointer;

    &:disabled {
      opacity: 0.65;
      cursor: default;
    }
  }
`;
